import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, Route } from 'react-router-dom'
import { Layout } from './layout'
import './styles/index.scss'
import 'whatwg-fetch'
// import './Dummy';

// ReactDOM.render(<BrowserRouter>
//    <Route path="/" render={p => <Layout history={p.history} location={p.location} />} />
// </BrowserRouter>, document.getElementById("emdg-container"));

const el = document.getElementById('emdg-container')
if (el === null) throw new Error('Root container missing in index.html')

console.log('React-version:', React.version)

const root = ReactDOM.createRoot(el)

root.render(
  <div>
    <BrowserRouter>
      <Route path="/" render={(p) => <Layout history={p.history} location={p.location} />} />
    </BrowserRouter>
  </div>,
)
